import * as React from "react";
import { BaseModal } from "../../../atoms/base-modal";

interface ModalWithInputProps {
  isActive: boolean;
  onCancel: () => void;
  onBreak: () => void;
  onSubmit: () => void;
}

export const ConfirmMatrixCodeModal: React.FunctionComponent<
  ModalWithInputProps
> = ({ isActive, onCancel, onBreak, onSubmit }) => {
  return (
    <BaseModal
      isActive={isActive}
      title="二次元コードを生成"
      onClose={onCancel}
      style={{ width: "auto" }}
    >
      <section className="modal-card-body">
        <div className="notification is-warning is-light">
          <div>
            <span className={`icon has-text-warning`}>
              <i className={`fas fa-exclamation-triangle`} />
            </span>
            <strong>
              申請開始ページのURLが設定されていませんがよろしいですか？
            </strong>
          </div>
          <div className="content is-size-7 ml-5 mt-1">
            申請開始ページのURLが設定されていません。このまま二次元コードを作成することもできますが、手続きをコピーして差し替えたい場合、
            <br />
            同じ二次元コードは使用できなくなります。手続きをコピーした後も同じ二次元コードを使用したい場合には、
            <br />
            <span
              onClick={onBreak}
              style={{
                cursor: "pointer",
                textDecoration: "underline",
              }}
            >
              申請開始ページのURLを設定
            </span>
            したうえで、コピー前の手続きとコピー後の手続きで同じURLを設定すれば、同じ二次元コードが使用できます。
          </div>
        </div>
      </section>
      <footer className="modal-card-foot">
        <button className="button is-failure is-fullwidth" onClick={onCancel}>
          キャンセル
        </button>
        <button
          className="button is-danger is-outlined is-fullwidth"
          onClick={onSubmit}
        >
          警告を無視して二次元コードを生成する
        </button>
      </footer>
    </BaseModal>
  );
};
